<template>
  <custom-callout
    :border-color="color"
    class="mb-3 custom-callout"
    :has-toggle="false"
  >
    <div class="row align-items-center mx-0 px-2 py-2">
      <div
        class="col-md-2 col-sm-12 icon-container border-right border-right--variant d-flex d-md-block d-sm-flex"
      >
        <custom-balloon
          :background-color="color"
          class="mt-2 p-2 font-weight-normal font-16 flex-grow-1"
          :text="billingStatusName"
        />
        <div class="font-weight-bold color-black text-center mt-3 flex-grow-1">
          {{ billNumber }}
        </div>
      </div>
      <div class="col-12 d-none d-md-none d-sm-block">
        <hr />
      </div>
      <div class="col-md-7">
        <div class="row">
          <div class="col-md-3 col-sm-12">
            <div class="gray-6 font-14">
              Periodo:
            </div>
            <div class="font-weight-normal color-black">
              {{ period }}
            </div>
          </div>
          <div class="col-md-3 col-sm-12 mt-3 mt-md-0 mt-sm-3">
            <div class="gray-6 font-14">
              Centro:
            </div>
            <div class="font-weight-normal color-black">
              {{ centerName }}
            </div>
          </div>
          <div class="col-md-3 col-sm-12 mt-3 mt-md-0 mt-sm-3">
            <div class="gray-6 font-14">
              Monto:
            </div>
            <div class="font-weight-normal color-black">
              {{ totalBillAmount | price }}
            </div>
          </div>
          <div class="col-md-3 col-sm-12 mt-3 mt-md-0 mt-sm-3">
            <div class="gray-6 font-14">
              Fecha Estatus:
            </div>
            <div class="font-weight-normal color-black">
              {{ $formatDate(billingStatusDate, $templateDate.default) }}
            </div>
          </div>

          <div class="col-md-6 col-sm-12 mt-3">
            <div class="gray-6 font-14">
              Proveedor:
            </div>
            <div class="font-weight-normal color-black">
              {{ companyName }}
            </div>
          </div>
          <div class="col-md-3 col-sm-12 mt-3">
            <div class="gray-6 font-14">
              Servicios a ofrecer:
            </div>
            <div class="font-weight-normal color-black">
              {{ offeredService }}
            </div>
          </div>
          <div v-if="isDirectPayment" class="col-md-3 col-sm-12 mt-3">
            <div class="gray-6 font-14 mb-1">
              Facturación:
            </div>
            <span
              class="badge badge-pill badge p-2 px-2 mr-3 text-nowrap flex-shrink-0"
              :class="`border-color--green`"
              style="background-color: #e3ffe9"
            >
              <span class="font-weight-bold ml-1" :class="`color-green`">
                Pago Directo
              </span>
            </span>
          </div>
          <div class="col-md-6 col-sm-12 mt-3">
            <div class="gray-6 font-14">
              Intervenido por:
            </div>
            <div class="font-weight-normal color-black">
              {{ interventorUsers }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="col-md-3 col-sm-12 col-spacing d-flex align-items-center justify-content-end flex-nowrap mt-3 mt-md-0 mt-sm-3"
      >
        <action-button
          v-if="!canCancel"
          class="px-4 flex-shrink-0 transparent-color"
          i="fas fa-file-import"
          text="Entrar"
          variant="outline-success"
          @click="$emit('enter', id)"
        />
        <drop-down v-else class="actions-dropdown" :items="actionItems" />
      </div>
    </div>
    <div v-if="showCancel" class="row">
      <div class="col-md-9 col-sm-12">
        <div class="gray-6 font-14 mb-2">
          Comentario:
        </div>
        <validation-observer
          :ref="`submitUpdateBillingStatusRef-${id}`"
          novalidate
          tag="form"
        >
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-input
              v-model="cancelReason"
              custom-error-msg="Favor de entrar un comentario."
              :error="errors[0]"
            />
          </validation-provider>
        </validation-observer>
      </div>
      <div class="col-md-3 text-right mt-4">
        <action-button
          class="w-45"
          i="fas fa-times-circle"
          variant="outline-danger btn-cancel danger m-2 pl-4 pr-4"
          @click="showCancel = false"
        >
          Cancelar
        </action-button>
        <action-button
          i="fas fa-arrow-circle-right"
          variant="success pl-4 pr-4"
          @click="cancelEvent()"
        >
          Cambiar
        </action-button>
      </div>
    </div>
  </custom-callout>
</template>

<script>
import CustomCallout from 'custom-callout';
import CustomInput from 'CustomInput';
import CustomBalloon from '@/components/common/CustomBalloon';
import billingStatus from '@/utils/constants/billingStatus.js';

import { Colors } from '@/components/common';
import alert from '@/mixins/alert.mixin';

export default {
  name: 'HistoryResultRow',
  components: {
    CustomInput,
    CustomBalloon,
    CustomCallout,
  },
  mixins: [alert],
  props: {
    id: {
      type: Number,
      required: true,
    },
    period: {
      type: String,
      required: true,
    },
    centerName: {
      type: String,
      required: true,
    },
    totalBillAmount: {
      type: Number,
      required: true,
    },
    billingStatusId: {
      type: Number,
      required: true,
    },
    billingStatusName: {
      type: String,
      required: true,
    },
    billNumber: {
      type: String,
      required: true,
    },
    billingStatusDate: {
      type: String,
      required: true,
    },
    companyName: {
      type: String,
      required: true,
    },
    offeredService: {
      type: String,
      required: true,
    },
    interventors: {
      type: Array,
      required: true,
    },
    canCancel: {
      type: Boolean,
      default: false,
    },
    isDirectPayment: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    showCancel: false,
    cancelReason: '',
  }),
  computed: {
    color() {
      switch (this.billingStatusId) {
        case billingStatus.Aprobado:
        case billingStatus.Pagado:
          return 'green-light bg-green-light';
        case billingStatus.EnviadoFinanzas:
          return Colors.CHARDONNAY;
        case billingStatus.EnviadoFinanzasParcial:
          return Colors.CHARDONNAY;
        case billingStatus.Sometida:
        case billingStatus.PendienteIntervencion:
        case billingStatus.PendienteInformacion:
        case billingStatus.PendienteAprobacion:
        case billingStatus.PendientePreAprobacion:
        case billingStatus.PendienteRevision:
        case billingStatus.PendienteIntervencionRevision:
        case billingStatus.EnProcesoIntervencion:
        case billingStatus.EnProcesoDeAjuste:
          return Colors.YELLOW;
        case billingStatus.EnProcesoIntervencionObjetada:
        case billingStatus.PendienteIntervencionObjetada:
          return Colors.VIOLET;
        case billingStatus.Preliminar:
        case billingStatus.CanceladoPorProveedor:
        case billingStatus.DevueltoTPFA:
          return Colors.BROWN;
        case billingStatus.EnEsperaFondos:
        case billingStatus.EnEsperaAsistenciaTecnica:
        case billingStatus.EnEsperaAprobacionPO:
          return Colors.PINK;
        default:
          return '';
      }
    },
    actionItems() {
      return [
        {
          name: 'goto',
          label: 'Entrar',
          icon: 'fas fa-file-import color-primary-1 pr-1',
          click: () => this.$emit('enter', this.id),
          border: 'bottom',
        },
        {
          name: 'cancel',
          label: 'Cancelar',
          icon: 'fas fa-times-circle color-primary-4 pr-1',
          click: () => (this.showCancel = true),
        },
      ];
    },
    interventorUsers() {
      if (!this.interventors || this.interventors.length === 0) return '-';
      const results = this.interventors.map((x) => x.name).join(', ');
      return results;
    },
  },
  methods: {
    async cancelEvent() {
      const refName = `submitUpdateBillingStatusRef-${this.id}`;
      const isValid = await this.$refs[refName].validate();

      if (!isValid) {
        this.ShowToast('Alerta', 'Información Incompleta', 'error');
        return;
      }

      const isConfirmed = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro(a) que desea cancelar la factura ${this.billNumber}?`,
        'Sí',
        'No'
      );

      if (!isConfirmed) return;

      this.showCancel = false;
      this.$emit('cancel', {
        billId: this.id,
        cancelReason: this.cancelReason,
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/shared/scss/config/_colors.scss';

.transparent-color {
  background: map-get($colors, 'gray-9') !important;
  white-space: nowrap;
  &:hover {
    color: map-get($colors, 'green') !important;
  }
}

::v-deep .input-label {
  color: map-get($colors, 'gray-6');
  font-size: 14px !important;
  font-weight: normal !important;
}

.custom-callout-invoice {
  ::v-deep .callout-container {
    border-left-width: 5px;
  }
}

@media only screen and (max-width: 768px) {
  .border-right--variant {
    border-right: unset !important;
  }
}
</style>
